import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { checkAdminAccess } from '../../utils/adminService';

const AdminProtectedRoute = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminCheckLoading, setAdminCheckLoading] = useState(true);
  const [adminCheckComplete, setAdminCheckComplete] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      if (!authLoading && user) {
        try {
          setAdminCheckLoading(true);
          const adminStatus = await checkAdminAccess();
          setIsAdmin(adminStatus);
        } catch (error) {
          console.error('관리자 권한 확인 실패:', error);
          setIsAdmin(false);
        } finally {
          setAdminCheckLoading(false);
          setAdminCheckComplete(true);
        }
      } else if (!authLoading && !user) {
        // 로그인되지 않은 경우
        setAdminCheckLoading(false);
        setAdminCheckComplete(true);
      }
    };

    checkAdmin();
  }, [user, authLoading]);

  // 인증 로딩 중이면 로딩 화면 표시
  if (authLoading || adminCheckLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">
            {authLoading ? '인증 확인 중...' : '관리자 권한 확인 중...'}
          </p>
        </div>
      </div>
    );
  }

  // 로그인되지 않은 경우 로그인 페이지로 리다이렉트
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 관리자가 아닌 경우 대시보드로 리다이렉트
  if (adminCheckComplete && !isAdmin) {
    console.warn('관리자가 아닌 사용자의 관리자 페이지 접근 시도:', user?.email);
    return <Navigate to="/dashboard" replace />;
  }

  // 관리자인 경우 해당 컴포넌트 렌더링
  return children;
};

export default AdminProtectedRoute;